import Vue from 'vue'
import Test from "./test.vue"
console.log(Test);
export default{
  install:function(Vue){
    Vue.component()
  }
}


// WEBPACK FOOTER //
// ./src/index.js